import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersExecutedUndeclared(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.ordersExecutedUndeclared}
      subtitle={texts.ordersExecutedUndeclaredTooltip}
    >
      <Row
        onClick={onSelect}
        text={texts.ordersExecutedUndeclared}
        value={count}
        disabled={count === 0}
        testId="plan-summary-executed-undeclared-orders"
      />
    </Tooltip>
  )
}
